'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".XIcon-module_container__Xx8sr{height:auto;vertical-align:baseline;vertical-align:initial;width:1rem;fill:#000}";
var styles = {"container":"XIcon-module_container__Xx8sr"};
styleInject["default"](css_248z, '8abf40ab-134a-42c7-a555-8ba51f10d3df');

exports["default"] = styles;
